import React, { useState, useRef, useEffect } from "react";
import { useHistory } from "react-router-dom";
import Footer from "../../components/Footer.js";
import HeaderTransprent from "../../components/HeaderTransprent.js";
import TagHeading from "../../components/ui/TagHeading.js";
import Button from "../../components/ui/Button.js";
import ButtonBorder from "../../components/ui/ButtonBorder.js";
import Heading from "../../components/ui/Heading.js";
// import ButtonReadmore from "../../components/ui/ButtonReadmore.js";
// import Different from "../../components/ui/Different.js";
import Stats from "../../components/ui/Stats.js";
import ContactForm from "../../components/ui/ContactForm.js";
import JsonData from "../Json/leadership.json";
import { GoCheckCircle } from "react-icons/go";
// import { MdOutlineArrowForwardIos, MdOutlineArrowBackIos } from "react-icons/md";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Navigation } from "swiper/modules";
// import "swiper/css";
// import "swiper/css/navigation";

// console.log('JsonDataJsonDataJsonDataJsonDataJsonDataJsonData', JsonData);

const Home = () => {

  const formRef = useRef(null);
  const history = useHistory();

  // const handleClick = (field) => {
  //   history.push(field ? `/${field}` : "/");
  // };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleScrollToForm = () => {
    formRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const [activeIndex, setActiveIndex] = useState(0);
  const rightRefs = useRef([]);
  const rightScrollRef = useRef(null);

  useEffect(() => {
    if (!rightScrollRef.current) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveIndex(Number(entry.target.dataset.index));
          }
        });
      },
      {
        root: rightScrollRef.current,
        threshold: 0.6,
      }
    );

    rightRefs.current.forEach((el) => el && observer.observe(el));

    return () => observer.disconnect();
  }, []);

  const [activeTab, setActiveTab] = useState(JsonData.philosophyTabs[0].key);

  const activeContent = JsonData.philosophyTabs.find(
    (tab) => tab.key === activeTab
  );

  return (
    <>
      <div className="">

        <HeaderTransprent />
        <section className="bg-cover bg-no-repeat bg-right w-full h-auto bgpagecolor" style={{ backgroundImage: `url('/img/assets/home/about-us.webp')`, }}>
          <div className="w-full h-full">
            <div className="flex md:flex-row flex-col gap-10 mx-auto px-4 xl:px-0 md:py-20 w-full 2xl:w-[80%] xl:w-11/12 md:h-[50rem] h-[35rem]">
              <div className="flex flex-col justify-center space-y-8 md:max-w-4xl my-auto pt-10 md:pt-16 md:pb-12 w-full h-full md:text-left text-center">
                <TagHeading className="textactive" text="ABOUT US" />
                <Heading className="textwhite" text="Leadership That Moves Organizations Forward" />
                <div className="font-medium text-xl md:text-2xl text-white">
                  <p className="pb-2">We help organizations make leadership decisions that shape <br /> performance, culture, and the future.</p>
                </div>
                {/* <div className="font-medium text-base md:text-lg text-white">
                  <p className="pb-2"> It’s about choosing the person your TOMORROW can rely on.</p>
                </div> */}
                <div className="flex items-center space-x-4">
                  <div className="flex justify-center md:justify-start items-center md:items-center gap-4 md:w-80 w-full">
                    <Button text="Explore Our Psychology" onClick={handleScrollToForm} />
                  </div>
                  <div className="flex justify-center md:justify-start items-center md:items-center gap-4 md:w-80 w-full">
                    <ButtonBorder text="Explore Our Methodology" onClick={() => history.push("/services")} />
                  </div>
                </div>
              </div>

              {/* <div className="flex justify-center items-center w-full">
                <img data-aos="fade-left" src="/img/assets/home/agrpartners.webp" alt="agrpartners" className="z-0" />
              </div> */}
            </div>
          </div>
        </section>

        <section className="bg-[#FFFFFF] py-20">
          <div className="gap-10 mx-auto px-4 xl:px-0 w-full 2xl:w-[80%] xl:w-11/12">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
              <div>
                <TagHeading className="textactive" text="OUR BELIEF" />
                <Heading className="textblack" text="Leadership defines destiny" />
                <p className="mt-6 textblack max-w-md leading-relaxed">We partner with organizations to identify, assess, and secure exceptional leaders who create lasting impact.</p>
                <button className="mt-8 inline-flex items-center bg-red-800 text-white px-6 py-3 text-sm font-medium hover:bg-red-900 transition">Explore Our Search Methodology</button>
              </div>
              <div className="space-y-6">
                <h2 className="font-semibold textblack">"In a world where strategies shift overnight and competition moves at lightning speed, one truth remains constant — leadership defines destiny."</h2>
                <p className="mt-2 textblack text-sm leading-relaxed max-w-md">Organizations do not rise because of systems, structures, or strategies alone. They rise because of the people who lead them.</p>
                <p className="mt-2 textblack text-sm leading-relaxed max-w-md">The right leader unlocks performance, inspires teams, shapes culture, and accelerates growth in ways no process can replicate.</p>
                <p className="mt-2 textblack text-sm leading-relaxed max-w-md">Leadership decisions, therefore, are not operational choices — they are future-shaping moments. <span className="font-semibold">This belief is the foundation of everything we do.</span></p>
              </div>
            </div>
          </div>
        </section>

        {/* Stats Section */}
        <Stats />

        {/* Our Foundation */}
        <section className="bg-[#9B26350F] py-20">
          <div className="gap-10 mx-auto px-4 xl:px-0 w-full 2xl:w-[80%] xl:w-11/12">
            <div className="text-center">
              <TagHeading className="textactive" text="WHY WE EXIST" />
              <Heading className="textblack" text="Our Foundation" />
              <p className="text-center mt-4 textblack text-xl font-semibold leading-relaxed">Guiding leadership with intention, clarity, and impact.</p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mt-16">
              {JsonData.ourFoundationData.map((card, i) => (
                <div key={i} className="flex flex-col gap-6 even:pt-8">
                  <img src={card.image} alt={card.label} className="rounded-t-lg" />
                  <p className="textgray text-xs">{card.label}</p>
                  <h3 className="textblack font-semibold text-xl">{card.title}</h3>
                  {JsonData.ourFoundationData[i].description.map((text, idx) => (
                    <p key={idx} className="textblack text-sm">{text}</p>
                  ))}
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Our Philosophy */}
        <section ref={formRef} className="bg-[#FFFFFF] py-20 scroll-mt-[120px]">
          <div className="gap-10 mx-auto px-4 xl:px-0 w-full 2xl:w-[80%] xl:w-11/12">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
              <div className="space-y-4">
                <TagHeading className="textactive" text="Our Methodology" />
                <Heading className="textblack" text="Our Philosophy" />
                <p className="md:text-lg text-base textblack">Leadership Is A Responsibility. Selecting Leaders Is A Craft. </p>
                <div className="flex justify-start pt-10">
                  <img src={activeContent.icon} alt={activeContent.label} className="w-full max-w-lg transition-all duration-300" />
                </div>
              </div>

              {/* RIGHT CONTENT */}
              <div className="space-y-6">
                <div className="space-y-4">
                  <p className="textblack mb-3 leading-relaxed">At Our philosophy integrates the science of talent, the power of strengths, and the four timeless pillars of leadership success — Having VIEW: <span className="font-semibold">Vision, Impact, Execution, and Wisdom.</span></p>
                  <p className="textblack leading-relaxed">These four pillars anchor how we evaluate, understand, and select leaders who can transform organizations.</p>
                </div>

                {/* TABS */}
                <div className="border-b border-red-700/30 flex xl:gap-10 lg:gap-0 mb-8 w-full">
                  {JsonData.philosophyTabs.map((tab) => (
                    <button
                      key={tab.key}
                      onClick={() => setActiveTab(tab.key)}
                      className={`pb-3 text-lg font-semibold transition w-full
                  ${activeTab === tab.key
                          ? "textwhite bgcolor lg:px-6 px-2 py-3"
                          : "textblack lg:px-6 px-2 py-3"
                        }`}
                    >
                      {tab.label}
                    </button>
                  ))}
                </div>

                {/* TAB CONTENT */}
                <div>
                  <h2 className="textblack font-semibold md:text-xl text-lg mb-6">
                    {activeContent.content.heading}
                  </h2>

                  <p className="textblack mb-6">
                    {activeContent.content.description}
                  </p>

                  <ul className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    {activeContent.content.points?.map((point, index) => (
                      <li key={index} className="flex items-start gap-3 textblack">
                        <GoCheckCircle size={26} className="textactive shrink-0" />
                        <span className="font-semibold">{point}</span>
                      </li>
                    ))}
                  </ul>

                  {/* ✅ ONLY for Wisdom */}
                  {activeContent.content.heading2 && (
                    <p className="textblack my-4 font-medium">
                      {activeContent.content.heading2}
                    </p>
                  )}

                  {activeContent.content.points2 && (
                    <ul className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                      {activeContent.content.points2.map((point, index) => (
                        <li key={index} className="flex items-start gap-3 textblack">
                          <GoCheckCircle size={26} className="textactive shrink-0" />
                          <span className="font-semibold">{point}</span>
                        </li>
                      ))}
                    </ul>
                  )}

                  <p className="textblack mt-6">
                    {activeContent.content.paragraph}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-20 relative bg-cover bg-no-repeat bg-center w-full" style={{ backgroundImage: `url('/img/assets/home/our-point-of-view.webp')`, }}>
          <div className="gap-10 mx-auto px-4 xl:px-0 w-full 2xl:w-[80%] xl:w-11/12">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div>
                <TagHeading className="textactive" text="HOW WE THINK ABOUT LEADERSHIP" />
                <Heading className="textblack" text="Our Point Of View" />
                <p className="text-lg text-gray-700 font-semibold mb-10 pt-6">Leadership is not defined by hierarchy, tenure, or titles — but by impact.</p>
                {/* POINTS GRID */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                  {/* ITEM */}
                  {JsonData.ourPointsData.map((item) => (
                    <div key={item.id} className="flex gap-4">
                      <GoCheckCircle size={28} className="textactive shrink-0" />
                      <div>
                        <h4 className="font-semibold text-gray-900 mb-1">
                          {item.title}
                        </h4>
                        <p className="text-gray-600 text-sm">
                          {item.description}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="bg-[#F6F8FB] py-24">
          <div className="mx-auto w-full 2xl:w-[80%] xl:w-11/12 px-4">

            {/* HEADER */}
            <div className="text-center max-w-2xl mx-auto">
              <TagHeading className="textactive" text="Our Commitment" />
              <Heading className="textblack" text="Our Commitment" />
              <p className="mt-4 text-xl textblack font-semibold">We bring you in touch with the leaders who:</p>
            </div>

            {/* CONTENT GRID */}
            <div className="mt-20 grid grid-cols-1 lg:grid-cols-12 gap-y-16 gap-x-12 items-center">
              <div className="lg:col-span-4 lg:px-10 px-0 space-y-16">
                <div>
                  <div className="flex items-start gap-2 text-xl font-semibold text-gray-900">
                    <h2 className="shrink-0">1.</h2>
                    <h2>Leaders Who Inspire Possibility</h2>
                  </div>
                  <p className="pl-6 mt-4 text-sm textblack leading-relaxed">We identify leaders who think beyond today — those who can see the tomorrow, shape strategy, and create clarity in complexity. They expand the horizon of hope, make people believe in possibility.</p>
                </div>
                <div>
                  <div className="flex items-start gap-2 text-xl font-semibold text-gray-900">
                    <h2 className="shrink-0">2.</h2>
                    <h2>Leaders Who Command Trust Through Action</h2>
                  </div>
                  <p className="pl-6 mt-4 text-sm textblack leading-relaxed">Their integrity, clarity, and steadiness make people feel anchored and assured.</p>
                </div>
              </div>

              <div className="lg:col-span-4">
                <div className="">
                  <img src="/img/assets/home/our-commitment.webp" alt="our-commitment" className="rounded-2xl object-cover w-full h-full" />
                </div>
              </div>

              <div className="lg:col-span-4 lg:px-10 px-0 space-y-16">
                <div>
                  <div className="flex items-start gap-2 text-xl font-semibold text-gray-900">
                    <h2 className="shrink-0">3.</h2>
                    <h2>Leaders Who Lead With Compassion</h2>
                  </div>
                  <p className="pl-6 mt-4 text-sm textblack leading-relaxed">They understand people, respect emotions, and build workplaces where excellence becomes everyone’s natural effort.</p>
                </div>
                <div>
                  <div className="flex items-start gap-2 text-xl font-semibold text-gray-900">
                    <h2 className="shrink-0">4.</h2>
                    <h2>Leaders With Wisdom & Stability</h2>
                  </div>
                  <p className="pl-6 mt-4 text-sm textblack leading-relaxed">Their presence brings calm, clarity, and direction — especially when the stakes are high.</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <ContactForm />

        <Footer />
      </div>
    </>
  );
};


export default Home;
